import { useState } from "react";
import AdminManagementPage from "./AdminManagementPage";
import { Tabs, Tab, Box } from "@mui/material";
import TimeListAdmin from "./TimeListAdmin";

export default function AdminManagementIndex() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <main className="min-h-screen p-4 md:p-8">
      <div className="">

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handleChange} aria-label="admin tabs">
            <Tab label="Time List" />
            <Tab label="Admin Management" />
          </Tabs>
        </Box>
        <Box >
          {value === 0 && <TimeListAdmin />}
          {value === 1 && <AdminManagementPage />}
        </Box>
      </div>
    </main>
  );
}
